import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RequestCacheService {
  cache: any;
  local = 'e.cache';

  constructor() {
    this.cache = JSON.parse(localStorage.getItem(this.local) || '{}');
  }

  get getCache(): any {
    return this.cache;
  }

  removeAllCache() {
    this.cache = {};
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }
  removeProjectCache() {
    this.removeBacklog();
    this.removeRequirement();
    this.removeSprint();
    this.removeRoadblock();
    this.removeFix();
    this.removeTracker();
    this.removeQNA();
  }

  requirementWaterFallView(args: any) {
    if (args.activeLink) {
      this.cache.requirementWaterFallView = {
        ...this.cache.requirementWaterFallView,
        ...args
      };
      localStorage.setItem(this.local, JSON.stringify(this.cache))
    }
  }
  
  removeRequirementWaterFallView() {
    this.cache.requirementWaterFallView = {};
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }

  requirement(args: any) {
    if (args.pageSize && args.pageNumber) {
      args.pageSize = parseInt(args.pageSize) * (parseInt(args.pageNumber) + 1)
    }
    this.cache.requirement = {
      ...this.cache.requirement,
      ...args
    };
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }
  removeRequirement() {
    this.cache.requirement = {};
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }
  sprint(args: any) {
    this.cache.sprint = {
      ...this.cache.sprint,
      ...args
    };
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }
  removeSprint() {
    this.cache.sprint = {};
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }
  roadblock(args: any) {
    this.cache.roadblock = {
      ...this.cache.roadblock,
      ...args
    }
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }
  removeRoadblock() {
    this.cache.roadblock = {};
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }

  backlog(args: any){
    this.cache.backlog = {
      ...this.cache.backlog,
      ...args
    };
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }

  removeBacklog(){
    this.cache.backlog = {};
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }

  /** Project **/
  project(args: any) {
    this.cache.project = {
      ...this.cache.project,
      ...args
    };
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }
  template(args: any) {
    this.cache.template = {
      ...this.cache.template,
      ...args
    };
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }
  removeProject() {
    this.cache.project = {};
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }

  fix(args: any) {
    this.cache.fix = {
      ...this.cache.fix,
      ...args
    }
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }

  removeFix() {
    this.cache.fix = {};
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }
  tracker(args: any) {
    this.cache.tracker = {
      ...this.cache.tracker,
      ...args
    }
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }
  removeTracker() {
    this.cache.tracker = {};
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }

  qNA(args: any) {
    this.cache.qa = {
      ...this.cache.qa,
      ...args
    }
    console.log('@HqNA', this.cache.qa, args);
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }
  
  removeQNA() {
    this.cache.qa = {};
    localStorage.setItem(this.local, JSON.stringify(this.cache))
  }
}

